// Plugin to install auth globally in vue
import { Courts } from "./main.js";

export const CourtsPlugin = {
  install(Vue, options) {
    Vue.Courts = new Courts(options.config);
  }
};
